<template>
  <div class="c--social_social-login display-flex align-content-center justify-content-center tw-gap-4 sm:tw-gap-7.5">
    <a
      v-for="(item, index) in buttons"
      :key="`social-button-${index}`"
      :data-testid="`${item.name}-social`"
      :class="`display-flex justify-content-center align-items-center box-rounded shadowed square-44 tw-flex-shrink-0 cursor-pointer social-login--${item.name}`"
      @click.prevent="onClick(item.name)"
    >
      <img
        :src="`/assets/images/icons/${item.name}-icon1.svg`"
        width="22"
        height="22"
        loading="eager"
        class="square-22"
        :alt="item.name"
      />
    </a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        buttons: [
          {
            name: 'apple',
          },
          {
            name: 'facebook',
          },
          {
            name: 'google',
          },
        ],
      }
    },

    methods: {
      onClick(name) {
        this.$emit('onClickSocialLink', name)
      },
    },
  }
</script>

<style lang="scss">
  .social-login--apple {
    padding-top: 7px;
    padding-bottom: 12px;
    background: black;
    color: white;
    font-family: sans-serif !important;
    font-size: 19px !important;
    text-transform: none !important;
    letter-spacing: 0;
    font-weight: 500;
  }

  .social-login--facebook {
    background-color: #1877f2;
    box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
  }

  .social-login--facebook:hover {
    background: #1877f2 !important;
  }

  .social-login--apple:hover {
    background: black !important;
    color: white !important;
  }

  .social-login--apple > img {
    display: block;
    margin-right: 0;
    height: 25px !important;
    width: 25px !important;
  }

  .social-login--google > img {
    image-rendering: auto;
  }
</style>
